import SliderImageWithText, { SliderImageWithTextProps } from './SliderImageWithText'
export default SliderImageWithText
export { SliderImageWithText, type SliderImageWithTextProps }
